import React from "react";
import {
  Grid,
  Typography,
  Box,
  Card,
  CardContent,
  Divider,
} from "@mui/material";
import certificate from "./../images/certificates.jpeg";
import "./Aboutus.css";
import VisionAndMision from "./VisionAndMision";
//import Values from './Values';
import Custom from "./Custom";
import useMediaQuery from "@mui/material/useMediaQuery";
import Values from "./Values";

const AboutUs = () => {
  const vMediaQuery = useMediaQuery("(max-width:600px)");

  return (
    <>
      <Box
        sx={{
          flexGrow: 1,
          padding: vMediaQuery ? "36px 16px" : "36px",
          textAlign: "center",
        }}
      >
        <Card sx={{ boxShadow: 0, padding: vMediaQuery ? "0px" : "16px" }}>
          <CardContent>
            <Grid container>
              <Grid item xs={12}>
                <Typography
                  variant="h4"
                  sx={{
                    color: "#707070",
                    fontSize: vMediaQuery ? "24px" : "34px",
                    fontFamily: "EB Garamond",
                  }}
                >
                  GDR Consultancy <br />{" "}
                  <strong
                    style={{
                      color: "green",
                      margin: 0,
                      fontWeight: 800,
                      fontSize: vMediaQuery ? "24px" : "34px",
                    }}
                  >
                    Who we are{" "}
                  </strong>
                </Typography>
                <Typography
                  variant="body1"
                  sx={{
                    padding: vMediaQuery ? "10px" : "20px",
                    color: "#808080",
                  }}
                >
                  We take the time to understand your business and focus on
                  adding value that enhances your customer and{" "}
                  {vMediaQuery || <br />}
                  employee experiences by leveraging Microsoft Dynamics 365
                  Applications, we help you transform
                  {vMediaQuery || <br />}
                  inside out and guide you through the Digital Transformation
                  Journey, acting as
                  {vMediaQuery || <br />} your trusted partner who is committed
                  to your success.
                </Typography>
              </Grid>
            </Grid>
            <Divider
              sx={{
                //backgroundColor: "white",

                margin: vMediaQuery ? "10px 0px" : "20px 200px",
              }}
            />
            <Grid container sx={{ padding: "14px 0px 0px 0px" }}>
              <Grid item xs={12}>
                <Typography
                  variant="h4"
                  sx={{
                    color: "#707070",
                    fontSize: vMediaQuery ? "24px" : "34px",
                    fontFamily: "EB Garamond",
                  }}
                >
                  Our Microsoft Dynamics 365 Certifications{" "}
                </Typography>
                <Typography
                  variant="body1"
                  sx={{
                    padding: vMediaQuery ? "10px" : "20px",
                    color: "#808080",
                  }}
                >
                  GDR’s commitment to provide exceptional Dynamics 365 Services
                  is shown in earnest <br /> by our ever-growing pool of
                  Dynamics 365 certified experts in the following fields.
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <div className="certify-contanier">
                  <img
                    className="certify"
                    alt="certificates"
                    src={certificate}
                  />
                </div>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Box>

      <VisionAndMision />
      <Values />
      <Custom />
    </>
  );
};

export default AboutUs;
